export { HfdiTag } from "./pages/hfdiTag";
